import { Stack } from '@mui/material';
import { GridToolbarQuickFilterProps } from '@mui/x-data-grid-pro';
import * as React from 'react';

import { TableFilter, TableFilterProps } from '../../TableFilter';
import { QuickFilterSearchbar } from './QuickFilterSearchbar';

export interface SearchFilterToolbarProps {
  searchProps?: Partial<GridToolbarQuickFilterProps>;
  tableFilterProps: TableFilterProps;
  rightToolbarContent?: React.ReactNode;
}

export function SearchFilterToolbar({
  searchProps = {},
  tableFilterProps,
  rightToolbarContent,
}: SearchFilterToolbarProps) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      mb={2}
    >
      <Stack direction="row" justifyContent="flex-start" spacing={1}>
        <QuickFilterSearchbar
          debounceMs={500}
          variant="outlined"
          placeholder=""
          {...searchProps}
        />
        <TableFilter {...tableFilterProps} />
      </Stack>
      {rightToolbarContent && rightToolbarContent}
    </Stack>
  );
}
